import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

import { SelectedOption } from '../model/selected-option';

@Injectable()
export class OptionsAsideService {
    informationAsideStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
    categoryChangeAsideStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
    optionType: BehaviorSubject<string> = new BehaviorSubject(null);
    informationModel: BehaviorSubject<any> = new BehaviorSubject(null);
    options: BehaviorSubject<any> = new BehaviorSubject(null);
    selectedoptions: BehaviorSubject<any> = new BehaviorSubject(null);

    /// Include/Exclude Modal
    includeExcludeModalStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
    allOptions: BehaviorSubject<any> = new BehaviorSubject(null);
    allSelectedOptions: BehaviorSubject<any> = new BehaviorSubject(null);
    includeExcludeOption: BehaviorSubject<any> = new BehaviorSubject(null);

    openInformationAside(informationModel: any, optionType: string, selectedoptions: SelectedOption[]) {
        this.informationAsideStatus.next(true);
        this.optionType.next(optionType);
        this.informationModel.next(informationModel);
        this.selectedoptions.next(selectedoptions);
    }
    closeInformationAside() {
        this.informationAsideStatus.next(false);
    }

    closeChangeCategoryAside() {
        this.categoryChangeAsideStatus.next(false);
    }


    openIncludeExcludeModal(selectedoptions: SelectedOption[], incrementQuantityOption: SelectedOption) {
        this.includeExcludeModalStatus.next(true);
        this.selectedoptions.next(selectedoptions);
        this.includeExcludeOption.next(incrementQuantityOption);
    }

    closeIncludeExcludeModal() {
        this.includeExcludeModalStatus.next(false);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/options-aside.service.ts